(function () {
  function closeDetails(details) {
    details.removeAttribute('open');
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var desktopDetails = Array.prototype.slice.call(document.querySelectorAll('header-menu > details.ah-header-details'));

    desktopDetails.forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        desktopDetails.forEach(function (other) {
          if (other !== details) closeDetails(other);
        });
      });
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('header-menu')) return;
      desktopDetails.forEach(closeDetails);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      desktopDetails.forEach(closeDetails);
    });

    var mobileParentDetails = Array.prototype.slice.call(document.querySelectorAll('.ah-mobile-menu > .ah-mobile-menu__row > details.ah-mobile-menu__details'));
    mobileParentDetails.forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        mobileParentDetails.forEach(function (other) {
          if (other !== details) closeDetails(other);
        });
      });
    });
  });
})();
